// Single source of truth for the editor's visual-quality tiers — shared by
// sceneGraph.js (shadow map resolution) and Viewport.jsx (AO cost/pixel
// ratio), so the two stay in lockstep without duplicating the tuning values.
// AA (SMAA) is always on regardless of tier — only resolution/AO/pixel-ratio
// scale (except AO itself at the lowest tier, where it's skipped entirely for
// performance).
//
// Shadow *softness* comes from PCFShadowMap's `shadow.radius` (see
// SHADOW_RADIUS in sceneGraph.js) — a real multi-tap blur, not a resolution
// trick — so shadowMapSize here is just the normal crispness/perf lever.
export const QUALITY_LEVELS = ["low", "medium", "high"];

export const DEFAULT_QUALITY = "medium";

export const QUALITY_PRESETS = {
  low: {
    shadowMapSize: 1024,
    pixelRatioCap: 1,
    ao: { enabled: false },
  },
  medium: {
    shadowMapSize: 2048,
    pixelRatioCap: 1.5,
    ao: { enabled: true, resolutionScale: 0.75, samples: 16 },
  },
  high: {
    shadowMapSize: 4096,
    pixelRatioCap: 2,
    ao: { enabled: true, resolutionScale: 1, samples: 32 },
  },
};

export function resolveQualityPreset(qualityPreset) {
  return QUALITY_PRESETS[qualityPreset] || QUALITY_PRESETS[DEFAULT_QUALITY];
}
